export default __webpack_public_path__ + "static/4-0adc2e71f0ca05e4f4201391776dc5a7.jpeg";